import { createFileRoute } from '@tanstack/react-router';

interface ProvenanceSearch {
  artwork?: string;
}

export const Route = createFileRoute('/gallery/provenance')({
  validateSearch: (search: Record<string, unknown>): ProvenanceSearch => ({
    artwork:
      typeof search.artwork === 'string' && search.artwork !== '' ? search.artwork : undefined,
  }),
});
